import { Sort } from '@angular/material/sort';

export enum ECardSortOption {
  name = 'name',
  createdAt = 'createdAt',
  workspace = 'workspace',
}

export interface ICardSortMenuOption {
  id: ECardSortOption;
  labelKey: string;
}

export const CARD_SORT_MENU_OPTIONS: ICardSortMenuOption[] = [
  { id: ECardSortOption.name, labelKey: 'field.name' },
  { id: ECardSortOption.createdAt, labelKey: 'field.createdAt' },
  { id: ECardSortOption.workspace, labelKey: 'field.workspace' },
];

/** Pinned items always come first; the user-selected sort applies within the pinned and unpinned groups. */
const PINNED_FIRST_SORT: Sort = { active: 'isPinned', direction: 'desc' };

export const CARD_SORT_REQUEST_SORTS: Record<ECardSortOption, Sort[]> = {
  [ECardSortOption.name]: [PINNED_FIRST_SORT, { active: 'name', direction: 'asc' }],
  [ECardSortOption.createdAt]: [PINNED_FIRST_SORT, { active: 'createdAt', direction: 'desc' }],
  [ECardSortOption.workspace]: [PINNED_FIRST_SORT, { active: 'workspace.name', direction: 'asc' }],
};
